var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.934 46.5413H82.6425C75.21 46.5413 69.1837 52.5675 69.1837 60C69.1837 67.4325 75.21 73.4588 82.6425 73.4588H108.934C110.903 73.4588 112.5 71.8613 112.5 69.8925V50.1075C112.5 48.1388 110.903 46.5413 108.934 46.5413ZM82.2412 64.0088C80.025 64.0088 78.2325 62.2125 78.2325 60C78.2325 57.7875 80.0287 55.9913 82.2412 55.9913C84.4537 55.9913 86.25 57.7838 86.25 60C86.25 62.2163 84.4537 64.0088 82.2412 64.0088Z",
    fill: "url(#paint0_linear_20_182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6462 40.9162H104.587V40.0125C104.587 25.9312 93.1725 14.5125 79.0875 14.5125H33C18.915 14.5125 7.5 25.9275 7.5 40.0125V79.9874C7.5 94.0687 18.915 105.487 33 105.487H79.0875C93.1687 105.487 104.587 94.0724 104.587 79.9874V79.0837H82.6462C72.1237 79.0837 63.5662 70.5225 63.5662 60C63.5662 49.4775 72.1237 40.9162 82.6462 40.9162ZM36.2512 53.0625H26.25C24.3862 53.0625 22.875 51.5512 22.875 49.6875C22.875 47.8237 24.3862 46.3125 26.25 46.3125H36.2512C38.115 46.3125 39.6263 47.8237 39.6263 49.6875C39.6263 51.5512 38.115 53.0625 36.2512 53.0625ZM52.5 37.8262H26.25C24.3862 37.8262 22.875 36.315 22.875 34.4512C22.875 32.5875 24.3862 31.0762 26.25 31.0762H52.5C54.3637 31.0762 55.875 32.5875 55.875 34.4512C55.875 36.315 54.3637 37.8262 52.5 37.8262Z",
    fill: "url(#paint1_linear_20_182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_182",
    x1: 69.1837,
    y1: 60,
    x2: 116.064,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_182",
    x1: 7.5,
    y1: 60,
    x2: 112.576,
    y2: 59.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet1);
export default __webpack_public_path__ + "static/media/wallet1.5f22fe743d84027aad95111599b03bd8.svg";
export { ForwardRef as ReactComponent };